import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import Cookies from "js-cookie";
import { setStatusFail } from "../statusFail/statusFailSlice";

const initialState = {
  services: [],
  service: null,
  totalPages: 1,
  isLoading:false,
  error: null,
  form:false
};

const ADMIN_URL = process.env.REACT_APP_ADMIN_URL;



export const getServices = createAsyncThunk(
  "service/getServices",
  async({locationId,page,limit,sortBy,order},{rejectWithValue,dispatch})=>{
   
try {
  const resposne = await axios.get(`${ADMIN_URL}/service?page=${page}&limit=${limit}&sortBy=${sortBy}&order=${order}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("Token")}`,
      'location-id':locationId,
       tenantId: Cookies.get("TenantId"),
    },
  })
   
  return resposne.data.data
} catch (error) {
 
  if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
    const route = "/status-failed"
    await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
  }
  return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
}
  }
)


export const createService = createAsyncThunk(
  "service/createService",
  async (data, { rejectWithValue,dispatch }) => {
 
    try {
      const response = await axios.post(`${ADMIN_URL}/service`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      dispatch(getServices({locationId:null,page:null,limit:null,sortBy:"name",order:"asc"}))
      return response.data.data;
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
            const route = "/status-failed"
            await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
          }
          return rejectWithValue(error.response?.data?.error?.message);
    }
  }
);

export const updateService = createAsyncThunk(
  "service/updateService",
  async ({ id, data }, { rejectWithValue ,dispatch}) => {
    try {
      const response = await axios.patch(`${ADMIN_URL}/service/${id}`, data, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      });
      return {id,data};
    } catch (error) {
        if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
            const route = "/status-failed"
            await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
          }
          return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
);


export const getSingleService = createAsyncThunk(
  'service/getSingleService',
  async(id,{rejectWithValue,dispatch})=>{
    try {
      const response=  await axios.get(`${ADMIN_URL}/service/${id}`, {
        headers: {
          Authorization: `Bearer ${Cookies.get("Token")}`,
        },
      })
      return response.data.data
    } catch (error) {
      if(error.response?.data?.errorCode == "STATUS_CHECK_TENANT_DENIED"){
        const route = "/status-failed"
        await dispatch(setStatusFail({tenants:error.response.data.tenants,navigate:route}))
      }
      return rejectWithValue(error.response?.data?.error?.message || "Something went wrong");
    }
  }
)



const servicSlice = createSlice({
  name: "service",
  initialState,
  reducers: {
    clearServiceError: (state) => {
      state.error = null;
    },
    clearServiceData:(state)=>{
      state.service={};
    },
    toggleFormState:(state)=>{
      state.form = !state.form
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(createService.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(createService.fulfilled, (state, action) => {
        state.isLoading = false;
        // state.services.push(action.payload);
      })
      .addCase(createService.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(updateService.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(updateService.fulfilled, (state, action) => {
        state.isLoading = false;
        const index = state.services.findIndex((service) => service._id === action.payload.id);
        if (index !== -1) {
          state.services[index] = {...state.services[index],...action.payload.data};
        }
      })
      .addCase(updateService.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getServices.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(getServices.fulfilled, (state, action) => {
        state.isLoading = false;
        state.services = action.payload.data;
        state.totalPages = action.payload.totalPages;
      })
      .addCase(getServices.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      .addCase(getSingleService.pending,(state)=>{
        state.isLoading=true;
        state.error=null;
      })
      .addCase(getSingleService.fulfilled,(state,action)=>{
        state.isLoading=false;
        state.service=action.payload;
      })
      .addCase(getSingleService.rejected,(state,action)=>{
        state.isLoading=false;
        state.error=action.payload;
      })
      ;
  },
});

export const { clearServiceError, clearServiceData,toggleFormState} = servicSlice.actions;
export default servicSlice.reducer;
